import React from 'react';
import { Query, Mutation } from '@apollo/client/react/components';

import CurrentUserQuery from 'buyside/graphql/queries/JobApplicationCurrentUser';
import CreateJobApplicationMutation from 'buyside/graphql/mutations/CreateJobApplication';

import JobApplicationsPage from 'buyside/components/presentation/JobApplicationsPage/jobApplicationsPage';

const JobApplicationsPageContainer = ({ jobPostId }) => (
  <Query query={CurrentUserQuery} variables={{ jobPostId }}>
    {({ loading, error, data = {} }) => {
      return (
        <Mutation mutation={CreateJobApplicationMutation}>
          {mutate => {
            const createJobApplication = variables => mutate({ variables });

            return (
              <JobApplicationsPage
                loading={loading}
                error={error}
                currentUser={data.currentUser}
                jobPost={data.jobPost}
                createJobApplication={createJobApplication}
              />
            );
          }}
        </Mutation>
      );
    }}
  </Query>
);

export default JobApplicationsPageContainer;
